import { AppState, PostPageWithRecommendationsAdvertisementAppState } from '../../initialStateRegistration';

const getPostPage = (state: AppState) => (state as PostPageWithRecommendationsAdvertisementAppState).template;

export const getShowRecommendationsAdvertisement = (state: AppState) => getPostPage(state).showRecommendationsAdvertisement;

export const getRevcontentWidgetID = (state: AppState) => getPostPage(state).revcontentWidgetID;
